import { render, staticRenderFns } from "./nav-breadcrumb.vue?vue&type=template&id=313d496e"
import script from "./nav-breadcrumb.vue?vue&type=script&lang=js"
export * from "./nav-breadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports